import React, { FC } from 'react';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { useActiveInboxEmail } from 'src/models/callOffs/hooks';
import DownloadAllAttachments from 'src/shared/CallOffs/DownloadAllAttachents';
import AttachmentItem from 'src/shared/CallOffs/AttachmentsItem';

export const PreviewAttachments: FC = () => {
  const { data: callOff } = useActiveInboxEmail();
  const { t } = useTranslation();

  const zipFile = callOff?.zip;

  return (
    <>
      <div className={styles.container}>
        <h5 className={styles.attachmentsTitle}>{t('Common.listOfAttachments')}</h5>
        {zipFile && <DownloadAllAttachments url={zipFile.getUrl} fileName={zipFile.fileName} />}
      </div>
      <ul className={styles.attachments}>
        {callOff && callOff.attachments && !!callOff.attachments.length
          ? callOff.attachments.map(attachment => (
              <AttachmentItem key={attachment.filePath} attachment={attachment} eventSource="Call offs - Preview" />
            ))
          : '—'}
      </ul>
    </>
  );
};

export default PreviewAttachments;
